import { VFC, memo } from 'react';
import { Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useLoginUser, initUserObj } from '../../../hooks/providers/useLoginUserProvider';
import { Auth } from 'aws-amplify';

type Props = {
  btnName: string;
  size?: string;
  onClose?: ()=>void;
};

export const LogoutButton: VFC<Props> = memo((props) => {
  const { btnName, size = 'xs', onClose = () =>('') } = props;
  const navigate = useNavigate();
  const { loginUser, setLoginUser } = useLoginUser();

  const onClickLogout = async() => {
    onClose();
    await Auth.signOut();
    setLoginUser(initUserObj);
    sessionStorage.clear();
    // localStorage.removeItem('AwsSupport.FailureManage.LastLoginTime');
    // NEC認証でなければ(Cognitoログイン)直接リンク、NEC認証であれば設定でlogin.htmlに遷移
    if( loginUser.username.indexOf('nec-authentication') < 0 ){ 
      const uri = new URL(window.location.href);
      window.location.href = uri.origin + '/login.html';
    }else{
      navigate('/login.html');
    }
  };
  
  return (
    <Button
      size={size}
      bg="orange.400"
      color="white"
      _hover={{ opacity: 0.8 }}
      onClick={onClickLogout}
    >
      {btnName}
    </Button>
  );
});